module.exports = __webpack_public_path__ + "static/media/whatsapp.031fbfc0.png";